<rt-activity-subscriptions-table
  *ngIf="canViewActivitySubscriptions"
  [types]="types"
  [title]="'app.subscriptions.company_v2' | translate"
>
  <ng-container *ngIf="hasRequisitions">
    <rt-activity-subscriptions-table-row
      *ngIf="abilities.viewRequisitions"
      icon="assignment-turned-in"
      [title]="'app.subscriptions.events_group.requisitions_created_deleted' | translate"
      [activitySubscriptions]="activitySubscriptions"
      [types]="types"
      [eventsGroup]="['requisitionCreated', 'requisitionDeleted']"
      (changeEvents)="changeEvents.emit($event)"
    >
    </rt-activity-subscriptions-table-row>
    <rt-activity-subscriptions-table-row
      *ngIf="abilities.viewRequisitions"
      icon="assignment-turned-in"
      [title]="'app.subscriptions.events_group.requisition_approvals_enabled_disabled' | translate"
      [activitySubscriptions]="activitySubscriptions"
      [types]="types"
      [eventsGroup]="['requisitionDisabled', 'requisitionEnabled']"
      (changeEvents)="changeEvents.emit($event)"
    >
    </rt-activity-subscriptions-table-row>
    <rt-activity-subscriptions-table-row
      *ngIf="abilities.viewRequisitions"
      icon="assignment-turned-in"
      [title]="'app.subscriptions.events_group.approval_flows_fields_added_removed' | translate"
      [activitySubscriptions]="activitySubscriptions"
      [types]="types"
      [eventsGroup]="[
        'requisitionApprovalFlowCreate',
        'requisitionApprovalFlowUpdate',
        'requisitionApprovalFlowRemove',
        'requisitionFormUpdated'
      ]"
      (changeEvents)="changeEvents.emit($event)"
    >
    </rt-activity-subscriptions-table-row>
  </ng-container>
  <rt-activity-subscriptions-table-row
    *ngIf="abilities.viewAllOffers"
    icon="work"
    [title]="'app.subscriptions.events_group.job_add_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['jobAdd', 'jobRemove', 'jobAutomaticallyCreatedFromRequisition']"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    *ngIf="abilities.manageRecruiters"
    icon="person-outline"
    [title]="'app.subscriptions.events_group.member_add_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['memberAdd', 'memberRemove']"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    *ngIf="abilities.shareCandidates"
    icon="share"
    [title]="'app.subscriptions.events_group.share_container_add_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['shareContainerAdd', 'shareContainerRemove']"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    *ngIf="abilities.manageCandidates"
    icon="import-export"
    [title]="'app.subscriptions.events_group.import_candidates_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['importFinish', 'importRevert', 'importRemove']"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    *ngIf="abilities.manageAttributes || abilities.manageDisqualifyReasons"
    icon="label"
    [title]="'app.subscriptions.events_group.tag_add_v2' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['tagAdd', 'tagRemove', 'disqualifyReasonAdd', 'disqualifyReasonRemove']"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <ng-container *ngIf="hasReferrals && abilities.manageReferrals">
    <rt-activity-subscriptions-table-row
      icon="navbar-referrals"
      [title]="'app.subscriptions.events_group.referral_program_updated_v2' | translate"
      [activitySubscriptions]="activitySubscriptions"
      [types]="types"
      [eventsGroup]="['referralProgramUpdated']"
      (changeEvents)="changeEvents.emit($event)"
    >
    </rt-activity-subscriptions-table-row>
    <rt-activity-subscriptions-table-row
      icon="reward"
      [title]="'app.subscriptions.events_group.referral_reward_claimed_v2' | translate"
      [activitySubscriptions]="activitySubscriptions"
      [types]="types"
      [eventsGroup]="['referralRewardClaimed']"
      (changeEvents)="changeEvents.emit($event)"
    >
    </rt-activity-subscriptions-table-row>
  </ng-container>
  <ng-container *ngIf="abilities.manageTexting && textingEnabled">
    <rt-activity-subscriptions-table-row
      icon="sms"
      [title]="'app.subscriptions.events_group.texting_enabled_disabled' | translate"
      [activitySubscriptions]="activitySubscriptions"
      [types]="types"
      [eventsGroup]="['textingEnabled', 'textingDisabled']"
      (changeEvents)="changeEvents.emit($event)"
    >
    </rt-activity-subscriptions-table-row>
    <rt-activity-subscriptions-table-row
      icon="sms"
      [title]="
        'app.subscriptions.events_group.texting_phone_number_registered_or_deleted' | translate
      "
      [activitySubscriptions]="activitySubscriptions"
      [types]="types"
      [eventsGroup]="[
        'textingPhoneNumberDeleted',
        'textingPhoneNumberRegistered',
        'textingPhoneNumberRemovedBySystem'
      ]"
      (changeEvents)="changeEvents.emit($event)"
    >
    </rt-activity-subscriptions-table-row>
  </ng-container>
</rt-activity-subscriptions-table>
